import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import AgentDetailPage from './pages/AgentDetailPage';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
    return (
        <ErrorBoundary>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/agent/:id" element={<AgentDetailPage />} />
                </Routes>
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App; 